export default {
  state: {
    // Estructura:
    // comentariosAuditoria: {
    //   [token]: {
    //     field1: "comentario",
    //     field2: "otro comentario"
    //   }
    // }
    comentariosAuditoria: {}
  },

  mutations: {
    addComentarioAuditoria(state, { token, field, comentario }) {

      // Si no existe el token, se crea
      if (!state.comentariosAuditoria[token]) {
        state.comentariosAuditoria[token] = {};
      }

      // Se agrega o reemplaza el comentario para ese field
      state.comentariosAuditoria[token][field] = comentario;
    },

    removeComentarioAuditoria(state, { token, field }) {
      if (!state.comentariosAuditoria[token]) return;

      delete state.comentariosAuditoria[token][field];

      // Limpia el token si se quedó vacío
      if (Object.keys(state.comentariosAuditoria[token]).length === 0) {
        delete state.comentariosAuditoria[token];
      }
    }
  },

  getters: {
    getComentariosByToken: (state) => (token) => {
      return state.comentariosAuditoria[token] || null;
    }
  }
};
